import { SweepLogoLight } from '../../icons/generalIcons';
import { Box } from '@mui/material';
import { CenteredBox } from '../pages/environments/styledComponents';
import { CenteredCircularProgress } from './CenteredCircularProgress';
import { colors } from '@sweep-io/sweep-design';

const LoadingSweep = () => (
  <div className="spinner">
    <CenteredBox sx={{ marginTop: '200px' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <CenteredCircularProgress color={colors.grey[800]} />
        <SweepLogoLight />
      </Box>
    </CenteredBox>
  </div>
);

export default LoadingSweep;
